import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TherapyPlanSubscriptionsGridRequest } from '../../../models/therapyPlanSubscribtionGridRequest';
import {
  TherapyPlansSubcriptionGridResponseData,
  TherapyPlansSubscriptionGridResponse,
} from '../../../models/therapyPlansSubcriptionGridResponse';
import * as moment from 'moment';
import { TherapyPlansService } from '../../../services/therapy-plans.service';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { AppointmentStatus } from 'projects/app-core/src/app/session/models/TherapistAppointment';

interface CheckboxOptions {
  label: string;
  value: string;
  checked: boolean;
}



@Component({
  selector: 'app-plan-subscription-table',
  templateUrl: './plan-subscription-table.component.html',
  styleUrl: './plan-subscription-table.component.scss',
})
export class PlanSubscriptionTableComponent {
  @Input() inputTableData!: TherapyPlansSubscriptionGridResponse;
  @Input() showBlockButton = false;
  @Input() showSendFeedbackButton = false;
  @Output() pageSizeChangeEvent = new EventEmitter<number>();
  @Output() resetFilterEvent = new EventEmitter<void>();
  @Output() exportDataEvent = new EventEmitter<void>();
  @Output() reloadEvent = new EventEmitter<void>();
  @Output() pageChangeEvent = new EventEmitter<number>();
  @Output() scrollEvent = new EventEmitter<number>();
  @Output() therapistNameEvent = new EventEmitter<string>();
  @Output() therapistEmailEvent = new EventEmitter<string>();
  @Output() searchByPlanNameEvent = new EventEmitter<string>();
  @Output() purchasedAtFilterDateChangeEvent = new EventEmitter<Date[]>();
  @Output() validTillFilterDateChangeEvent = new EventEmitter<Date[]>();
  @Output() paymentTypeFilterChangeEvent = new EventEmitter<string[]>();
  @Output() tagsFilterChangeEvent = new EventEmitter<string[]>();

  @Output() showTransferModal =
    new EventEmitter<TherapyPlansSubcriptionGridResponseData>();
  @Output() showSendFeedbackModal =
    new EventEmitter<TherapyPlansSubcriptionGridResponseData>();
  @Output() selectedItem = new EventEmitter<
    TherapyPlansSubcriptionGridResponseData | undefined
  >();
  @Input() pageSize = 10;
  pageSizeOptions = [10, 20, 50, 100];
  @Input() pageLoading = false;
  @Input() tableQuery: TherapyPlanSubscriptionsGridRequest | undefined;
  selectedSubscription: TherapyPlansSubcriptionGridResponseData | undefined;
  paymentTypeCheckBoxOptions: CheckboxOptions[] = [];
  tagsFilterOptions: CheckboxOptions[] = [];
  expandSet = new Set<string>();
  selectedTherapistId = '';
  transferTherapistLoading = false;
  planNameColumnSearch = '';
  purchasedAtColumnFilterDate = [];
  validTillColumnFilterDate = [];
  therapistName = '';
  therapistEmail = '';

  constructor(
    private therapyPlansService: TherapyPlansService,
    private toastService: ToastService,
    public utils: UtilsService,
  ) { }

  resetValues() {
    this.planNameColumnSearch = '';
    this.purchasedAtColumnFilterDate = [];
    this.validTillColumnFilterDate = [];
    this.therapistName = '';
    this.therapistEmail = '';
    this.expandSet.clear();
    this.selectedSubscription = undefined;
  }

  setPaymentTypeTherapyPlanSubscriptionGridFilterData(
    value: TherapyPlansSubscriptionGridResponse,
  ) {
    this.paymentTypeCheckBoxOptions = [];
    this.paymentTypeCheckBoxOptions = value.filterOptions.paymentTypes.map(
      (data) => {
        if (this.tableQuery?.filters?.PAYMENT_TYPE?.includes(data)) {
          return {
            label: this.utils.convertToTitleCase(data),
            value: data,
            checked: true,
          };
        } else {
          return {
            label: this.utils.convertToTitleCase(data),
            value: data,
            checked: false,
          };
        }
      },
    );
  }

  setTagTherapyPlanSubscriptionGridFilterData(
    value: TherapyPlansSubscriptionGridResponse,
  ) {
    this.tagsFilterOptions = [];
    this.tagsFilterOptions = value.filterOptions.tagsFilter.map((data) => {
      if (this.tableQuery?.filters?.TAGS?.includes(data)) {
        return {
          label: this.utils.convertToTitleCase(data),
          value: data,
          checked: true,
        };
      } else {
        return {
          label: this.utils.convertToTitleCase(data),
          value: data,
          checked: false,
        };
      }
    });
  }

  purchasedAtFilterDateChange($event: Date[]) {
    this.purchasedAtFilterDateChangeEvent.emit($event);
  }

  validTillFilterDateChange($event: Date[]) {
    this.validTillFilterDateChangeEvent.emit($event);
  }

  paymentTypeFilterChangeFn($event: string[]) {
    this.paymentTypeFilterChangeEvent.emit($event);
  }

  tagsFilterChangeFn($event: string[]) {
    this.tagsFilterChangeEvent.emit($event);
  }

  exportDataFn() {
    this.exportDataEvent.emit();
  }

  onExpandChange(
    id: string,
    checked: boolean,
    data: TherapyPlansSubcriptionGridResponseData,
  ) {
    if (checked) {
      this.expandSet.clear();
      this.expandSet.add(id);
      this.selectedSubscription = data;
      this.therapistName = '';
      this.therapistEmail = '';
      Object.keys(this.selectedSubscription.sessionDetails).forEach((key) => {
        if (
          this.selectedSubscription?.sessionDetails[key].sessionStatus ===
          AppointmentStatus.OPEN ||
          this.selectedSubscription?.sessionDetails[key].sessionStatus ===
          AppointmentStatus.PENDING
        ) {
          this.therapistEmail =
            this.selectedSubscription?.sessionDetails[key].therapistEmail || '';
          this.therapistName =
            this.selectedSubscription?.sessionDetails[key].therapistName || '';
        } else {
          if (this.therapistEmail === '' || this.therapistName === '') {
            this.therapistName =
              this.selectedSubscription?.sessionDetails[key].therapistName ||
              '';
            this.therapistEmail =
              this.selectedSubscription?.sessionDetails[key].therapistEmail ||
              '';
          }
        }
      });
      this.therapistEmailEvent.emit(this.therapistEmail);
      this.therapistNameEvent.emit(this.therapistName);
      this.selectedItem.emit(data);
    } else {
      this.expandSet.delete(id);
      this.selectedSubscription = undefined;
      this.therapistName = '';
      this.therapistEmail = '';
      this.therapistEmailEvent.emit(this.therapistEmail);
      this.therapistNameEvent.emit(this.therapistName);
      this.selectedItem.emit(undefined);
    }
  }

  convertDataAndTime(date: Date) {
    return moment(date).format(' DD/MM/YYYY hh:mm:A ');
  }

  showModalTransfer(data: TherapyPlansSubcriptionGridResponseData) {
    this.showTransferModal.emit(data);
  }

  showModalSendFeedback(data: TherapyPlansSubcriptionGridResponseData) {
    this.showSendFeedbackModal.emit(data);
  }

  fractionsOfSessions(data: string) {
    const textArray = data.split('/');
    return `${textArray[1]}/${textArray[0]}`;
  }

  resetFilter() {
    this.resetFilterEvent.emit();
  }

  scrollToTop() {
    this.scrollEvent.emit();
  }

  nzPageIndexChange(value: number) {
    this.pageChangeEvent.emit(value);
  }

  nzPageSizeChange(value: number) {
    this.pageSizeChangeEvent.emit(value);
  }

  fetchTherapyPlans() {
    this.reloadEvent.emit();
  }

  searchByPlanName() {
    this.searchByPlanNameEvent.emit(this.planNameColumnSearch);
  }

  @Output() openBlockMessageModalEvent = new EventEmitter<string>();
  @Output() onBlockSubscriptionEvent = new EventEmitter<string>();


  onBlockSubscription(subId: string) {
    this.onBlockSubscriptionEvent.emit(subId);
  }

  openBlockMessageModal(blockMessage: string) {
    this.openBlockMessageModalEvent.emit(blockMessage);
  }
}
